import { IconButton, styled } from '@mui/material';

const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

// Botón de acción de tabla (editar / ver): relleno BLANCO + ícono NEGRO en ambos modos,
// con hairline y sombra sutil para que destaque tanto sobre filas claras como oscuras.
// Hover con leve escala (lenguaje premium), sin glow dorado.
const StyledActionColumnButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  color: '#0A0A0A',
  border: `1px solid ${theme.palette.hairline.strong}`,
  boxShadow: '0 2px 6px rgba(17, 21, 27, 0.16)',
  borderRadius: 10,
  padding: 7,
  margin: '0 3px',
  transition: `transform 200ms ${EASE}, box-shadow 200ms ${EASE}`,
  '& svg': {
    fontSize: 20
  },
  '&:hover': {
    backgroundColor: '#FFFFFF',
    color: '#0A0A0A',
    transform: 'scale(1.06)',
    boxShadow: '0 6px 14px rgba(17, 21, 27, 0.22)'
  },
  '&:active': {
    transform: 'scale(0.96)'
  }
}));

export default StyledActionColumnButton;
